import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ArrowRight } from "lucide-react"
import MarketingLayout from "@/components/marketing/MarketingLayout"
import { Button } from "@/components/ui/button"

export default function MarketingContentPage({ pageKey, seoKey, jsonLd, children }) {
  const { t } = useTranslation()
  const base = `pages.${pageKey}`
  const sections = t(`${base}.sections`, { returnObjects: true, defaultValue: [] })
  const sectionList = Array.isArray(sections) ? sections : []

  return (
    <MarketingLayout seoKey={seoKey || pageKey} jsonLd={jsonLd}>
      <article className="pt-36 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-5">
            {t(`${base}.eyebrow`, { defaultValue: "" })}
          </p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-medium leading-[0.95]">
            {t(`${base}.title`)}
          </h1>
          <p className="mt-6 text-lg text-muted-foreground">{t(`${base}.subtitle`)}</p>
        </div>

        <div className="mx-auto max-w-3xl px-6 lg:px-10 mt-12 space-y-10 text-muted-foreground leading-relaxed">
          {children ||
            sectionList.map((section) => (
              <section key={section.title}>
                <h2 className="font-display text-2xl text-foreground tracking-tight font-medium mb-3">
                  {section.title}
                </h2>
                <p>{section.body}</p>
                {section.bullets?.length > 0 && (
                  <ul className="mt-4 space-y-2 list-disc pl-5">
                    {section.bullets.map((b) => (
                      <li key={b}>{b}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
        </div>

        <div className="mx-auto max-w-3xl px-6 lg:px-10 mt-16 pt-12 border-t border-border text-center">
          <h2 className="font-display text-2xl tracking-tight font-medium">
            {t(`${base}.ctaTitle`, { defaultValue: t("landing.ctaTitle") })}
          </h2>
          <p className="mt-3 text-muted-foreground">
            {t(`${base}.ctaBody`, { defaultValue: t("landing.ctaSubtitle") })}
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/signup">
              <Button size="lg" className="rounded-full">
                {t("common.startFreeTrial")} <ArrowRight strokeWidth={1.5} className="ml-1 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/pricing">
              <Button size="lg" variant="ghost" className="rounded-full">
                {t("common.seePricing")}
              </Button>
            </Link>
          </div>
        </div>
      </article>
    </MarketingLayout>
  )
}
